export default __webpack_public_path__ + "static/media/berrycake@2x.adbc3621.jpg";